import { useParams, useSearchParams } from 'react-router-dom'
import { useChosenCompany, useUser, useUserContext } from '../../../../context/UserProvider'
import { useQuery } from 'react-query'
import { fetchFuelReportDetails } from '../../../../api/newApi'
import FuelReportDetailsTable from '../components/FuelTables/FuelReportDetailsTable'
import { ExcelExportButton } from '../components/ExcelExporter'
import { ConsolidateInvoiceSelect } from '../../../cars/components/V3/_shared/ConsolidateInvoiceSelect'
import { excelFuelReportDetailsColumns } from '../components/FuelTables/excelUtils'
import type { FuelReportDetails as FuelReportDetailsItem } from '../../../../types'
import { mapMonth } from '../utils/mapMonth'

const FuelReportDetails = () => {
  const company = useChosenCompany()
  const companyId = company?.id
  const { date } = useParams()
  const [searchParams] = useSearchParams()
  const userContext = useUserContext() as any
  const contactId = useUser()?.user?.id
  const queryConsolidatedAgreementID = searchParams.get('consolidatedAgreementID')
  const consolidatedAgreementID = (queryConsolidatedAgreementID ||
    userContext?.consolidateInvoice?.ConsolidateCode) as any

  const [year, month] = date ? date.split('-') : ['', '']

  const { data: response, isLoading } = useQuery(
    ['fuelReportDetails', companyId, contactId, year, month, consolidatedAgreementID],
    () => fetchFuelReportDetails({ companyId: companyId || '', contactId: contactId || '', year, month, consolidatedAgreementID }),
    { enabled: !!companyId && !!contactId && !!year && !!month && !!consolidatedAgreementID },
  )

  const responseItems = (response as any)?.items
  const data = (Array.isArray(responseItems) ? responseItems : []) as FuelReportDetailsItem[]

  const columns = excelFuelReportDetailsColumns()
  const config = {
    columns,
    filename: `Drivstoffrapport_${year}_${month}.xlsx`,
    sheetName: `Drivstoffrapport_${year}_${month}`,
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col md:flex-row md:items-center gap-2 md:justify-between">
        <div className="flex flex-row justify-between ">
          <div className="flex flex-col md:items-center md:flex-row gap-2">
            <span className="text-xl font-medium text-primaryText">Detaljert drivstoffrapport</span>
            <span className=" hidden md:block text-lg text-secondaryText">/</span>
            <span className="text-lg text-secondaryText">
              {mapMonth(month)} {year}
            </span>
          </div>
          <div className="md:hidden">
            <ExcelExportButton data={data} config={config} />
          </div>
        </div>
        <div className="flex flex-row gap-2 w-full md:w-auto">
          <div className="flex-1 md:flex-none">
            <ConsolidateInvoiceSelect className="h-11 w-full" />
          </div>
          <div className="hidden md:block">
            <ExcelExportButton data={data} config={config} />
          </div>
        </div>
      </div>
      <FuelReportDetailsTable isLoading={isLoading} options={{ year, month }} data={data} />
    </div>
  )
}

export default FuelReportDetails
